/**
 * Everything the product is *called*, in one place, so renaming or white-
 * labelling is an edit here rather than a search across the codebase.
 *
 * The look (colours, fonts, the mark) lives in `apps/web/src/brand/`. The few
 * places that can't import this file — the HTML page title, the installable
 * app manifest and the phone-app config — are listed in that folder's README.
 */
export const BRAND = {
  /** Used in sentences, emails, page titles and legal copy. */
  name: "GridAction",
  /** The wordmark reads GR·D ACTION, with a small grid standing in for the I. */
  wordmark: { before: "GR", after: "D", second: "Action" },
  tagline: "Football grids for friends",
  /** One line under the name on the home page. */
  promise: "Where friends compete and legends are grid.",
  /** Shown to people who land on a shared board with no account. */
  watchNote: "Nothing here can be changed, and this app never handles money.",
  /** Where password-reset and notification emails come from, by name. */
  emailFromName: "GridAction",
  /**
   * The public address, for copy. Links and emails the server builds come from
   * its APP_URL setting instead, so the two are changed together at a cutover.
   */
  domain: "gridaction.app",
  /**
   * Who people write to. Each of these must exist as a mailbox or an alias
   * before the address is shown to anyone.
   */
  contact: {
    support: "support@gridaction.app",
    privacy: "privacy@gridaction.app",
    /** Receives custom board and rule requests. Never shown in the app, only written to. */
    admin: "admin@gridaction.app",
    /** The From address on password resets and notifications; nobody reads replies. */
    noReply: "no-reply@gridaction.app",
  },
  /**
   * A voluntary thank-you tip page on someone else's payment site (Ko-fi or Buy Me a
   * Coffee). Null hides every tip link. GridAction never sees a payment.
   */
  tipUrl: "https://ko-fi.com/gridaction" as string | null,
} as const;

/** "GridAction" — shorthand for the common case. */
export const PRODUCT_NAME = BRAND.name;
